// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* app.component.css */
.nav-pills {
  border-radius: 10px;
  border: 1.2px solid #eaeaea;
  margin-right: 5px;
}

.nav-pills .nav-link {
  border-radius: 8px;
  margin: 3px;
  padding: 4px 12px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  border-bottom: 0 !important;
}

.nav-pills .nav-link.active {
  background-color: #def6e5;
  color: #437869;
}

.nav-pills .nav-link.active.danger {
  background-color: #fbe7e9;
  color: #753e54;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/views/toggle-switch/toggle-switch.component.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/* app.component.css */\r\n.nav-pills {\r\n  border-radius: 10px;\r\n  border: 1.2px solid #eaeaea;\r\n  margin-right: 5px;\r\n}\r\n\r\n.nav-pills .nav-link {\r\n  border-radius: 8px;\r\n  margin: 3px;\r\n  padding: 4px 12px;\r\n}\r\n.nav-pills .nav-link.active,\r\n.nav-pills .show > .nav-link {\r\n  border-bottom: 0 !important;\r\n}\r\n\r\n.nav-pills .nav-link.active {\r\n  background-color: #def6e5;\r\n  color: #437869;\r\n}\r\n\r\n.nav-pills .nav-link.active.danger {\r\n  background-color: #fbe7e9;\r\n  color: #753e54;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
